// @flow
/* eslint-disable react/no-danger */
import React from 'react';
import cn from 'classnames';
import _ from 'lodash';
import { EVENT_TYPES, PART_TITLES } from 'client/constants/common';
import { Icon } from '../../Icon';
import { Title } from '../Title';

import css from './Timeline.scss';

type Props = {
	timeline: any[],
	teamsLogo: { [key: string]: string },
};

export function Timeline({ timeline, teamsLogo }: Props) {
	const separatorIndexes: number[] = [];
	_.map(timeline, (i, index: number) => {
		if (i.Event === EVENT_TYPES.MATCH_STATUS) {
			separatorIndexes.push(index);
		}
	});

	const dataArrays = [];
	_.map((separatorIndexes: number[]), function sliceData(i, index) {
		const newArr = timeline.slice(i + 1, separatorIndexes[index + 1]); // slice without title
		_.reverse(newArr);
		newArr.unshift(timeline[i]); // put title object to index = 0
		dataArrays[index] = newArr;
	});

	const eventRender = event => {
		return (
			<>
				{event.Event === EVENT_TYPES.IMAGE ? (
					<div className={css.image}>
						<img src={event.URL} alt="" />
						<p className={css.imageCaption} dangerouslySetInnerHTML={{ __html: event.Caption }} />
					</div>
				) : (
					<div
						className={cn(
							css.event,
							(event.Event === EVENT_TYPES.GOAL ||
								event.Event === EVENT_TYPES.OWN_GOAL ||
								event.Event === EVENT_TYPES.PENALTY_GOAL) &&
								css.goal
						)}
					>
						<div className={css.minute}>
							{event.Minute}
							<sup>&apos;</sup>
						</div>
						<Icon type={event.Event} width={20} height={20} />
						{event.Event === EVENT_TYPES.SECOND_YELLOW_CARD && (
							<Icon type={EVENT_TYPES.RED_CARD} width={20} height={20} className={css.redCard} />
						)}
						<p className={css.text} dangerouslySetInnerHTML={{ __html: event.Text }} />
					</div>
				)}
			</>
		);
	};

	const renderPenaliesEvent = event => {
		return (
			<div className={cn(css.event, css.eventPenalty)}>
				<div className={css.logo}>
					<img src={teamsLogo[event.Team]} alt={event.Team} />
				</div>
				<Icon type={event.Event} width={28} height={28} />
				<p className={css.text} dangerouslySetInnerHTML={{ __html: event.Text }} />
			</div>
		);
	};

	const renderGamePart = part => {
		return (
			<div className={css.gamePart} key={`${part[0].Event}-${part[0].Text}`}>
				{_.map(part, (event, index: number) => (
					<React.Fragment key={`${event.Event}-${event.Text || event.URL}`}>
						{index === 0 && <Title title={event.Text} className={css.title} />}
						{index >= 1 && part[0].Text !== PART_TITLES.PENALTIES && eventRender(event)}
						{index >= 1 && part[0].Text === PART_TITLES.PENALTIES && renderPenaliesEvent(event)}
					</React.Fragment>
				))}
			</div>
		);
	};

	return <div className={css.timeline}>{_.map(_.reverse(dataArrays), part => renderGamePart(part))}</div>;
}
